import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../redux";
import { ROUTES } from "../../constants";
import { getUserDisplayName } from "../../utils";

const ProfileDropdown: React.FC = () => {
  const navigate = useNavigate();
  const { user, role } = useAppSelector((state) => state.auth);
  const displayName = getUserDisplayName(user);

  const handleProfileClick = () => {
    if (role === "teacher") {
      navigate(`${ROUTES.TEACHER.ROOT}/profile`);
    } else {
      navigate(`${ROUTES.STUDENT.ROOT}/profile`);
    }
  };

  return (
    <div className="profile-dropdown-container">
      <button
        type="button"
        className="user-badge-btn"
        onClick={handleProfileClick}
        aria-label="Open Profile"
        title={displayName || undefined}
      >
        <div className="user-avatar">{displayName ? displayName.charAt(0) : ""}</div>
      </button>
    </div>
  );
};

export default ProfileDropdown;
